import React from 'react';
import calendarService from '../../services/calendarService';

/**
 * CalendarLegend Component
 * Displays color-coded legend for event types
 */
const CalendarLegend = ({ theme, visibleEventTypes = null }) => {
  // Get only visible event types or all types
  const displayTypes = visibleEventTypes || Object.keys(calendarService.constructor.EVENT_COLORS);
  
  if (displayTypes.length === 0) {
    return null; // Don't show legend if no events
  }
  
  // Check if we're on mobile
  const isMobile = window.innerWidth <= 768;
  
  // Styles
  const styles = {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: isMobile ? '10px' : '16px',
      justifyContent: 'center',
      marginTop: '12px',
      marginBottom: '16px',
      padding: '0 8px'
    },
    legendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      whiteSpace: 'nowrap'
    },
    colorDot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      flexShrink: 0,
      border: '1px solid rgba(0, 0, 0, 0.1)'
    },
    legendLabel: {
      fontSize: '11px',
      color: theme?.colors?.textSecondary || '#64748b'
    }
  };
  
  return (
    <div style={styles.container}>
      {displayTypes.map(type => (
        <div key={type} style={styles.legendItem}>
          <div 
            style={{
              ...styles.colorDot,
              backgroundColor: calendarService.constructor.EVENT_COLORS[type]
            }}
          />
          <span style={styles.legendLabel}>
            {calendarService.constructor.EVENT_TYPE_LABELS[type]}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CalendarLegend;